export default __webpack_public_path__ + "static/media/diagnostic-cta-bg.1a4b303d.png";